import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { NoUpcomingMeetingsCard } from './NoUpcomingMeetingsCard';
const emptyTodayWrapperCss = "egqaae0";
interface EmptyStateProps {
  type: 'NO_TODAY_MEETINGS' | 'NO_FUTURE_MEETINGS';
}

/**
 * Renders empty state cards for placeholder event types
 * Used when there are no meetings for a given time period
 */
export const EmptyState = ({
  type
}: EmptyStateProps) => {
  if (type === 'NO_TODAY_MEETINGS') {
    return <div className={emptyTodayWrapperCss}>
        <BodyText color="muted">
          {I18n.t('publisher.meetings.end_of_list.none_today')}
        </BodyText>
      </div>;
  }
  if (type === 'NO_FUTURE_MEETINGS') {
    return <NoUpcomingMeetingsCard />;
  }
  return null;
};

require("./EmptyState.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./EmptyState.tsx");